// Environment variables with fallbacks for design preview
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.placeholder.com',
  apiVersion: import.meta.env.VITE_API_VERSION || 'v1',
  analyticsId: import.meta.env.VITE_ANALYTICS_ID,
  gtagMeasurementId: import.meta.env.VITE_GTAG_MEASUREMENT_ID || import.meta.env.VITE_ANALYTICS_ID || 'G-Z6C0HH0D6Z',
  metaPixelId: import.meta.env.VITE_META_PIXEL_ID || '812112301280246',
  appEnv: import.meta.env.VITE_APP_ENV || 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};
